export * from './IconCommentAddFilled';
